import { APIResponse } from '@cbgms/api/helpers'
import { createAsyncApiAction } from '@cbgms/base/redux/create-async-action'

import { RentalClassOptions } from './rental-classes'

export const getCourtesyVehicleRentalClasses = (workorderUUID: string) =>
  createAsyncApiAction<APIResponse<RentalClassOptions>>('gms', {
    method: 'GET',
    url: `/proxy/lease-api/rental-classes/${workorderUUID}`
  })
